import { useQuery, useSession } from 'common/hooks';
import { UseQueryOptions } from 'common/types/Api.type';
import { getWinPeriodsApi } from '../services/win-periods.service';

export const useGetWinPeriods = (options?: UseQueryOptions) => {
  const { account: user } = useSession();
  const queryResponse = useQuery(
    ['win-periods', user.organizationId],
    () => getWinPeriodsApi(),
    options,
  );

  return {
    ...queryResponse,
    data: queryResponse.isSuccess ? queryResponse?.data.data : [],
  };
};
